import * as images from "@/components/images/Images";
import { SupportCardProps } from "@/components/screen/global-components/support/SupportCard";

export const getQuoteSupportCards: SupportCardProps[] = [
  {
    title: "FAQ",
    description:
      "Get immediate answers to your questions on translation best practices, our services, pricing, and more.",
    imageUrl: images.gridImage1,
    href: "/faq",
    linkLabel: "Learn more",
  },
  {
    title: "Call us",
    description:
      "Reach us at (833) 551-1381 Monday through Friday between the hours of 9 a.m. to 5 p.m EST. Outside of these hours, please leave us a message and we’ll return your call during business hours.",
    imageUrl: images.gridImage2,
  },
  {
    title: "Contact us",
    description:
      "Reach out to support@languex.co or use the form below for same day or sooner help with your projects or services, and for other questions and feedback.",
    imageUrl: images.supportGrid,
  },
  {
    title: "Our Office",
    description:
      "We are a global company with employees around the world, but proudly headquartered in Dublin, Ohio. Our address is 6605 Longshore St. Suite 240, 43017",
    imageUrl: images.gridImage4,
  },
];

export const getQuoteSupportData = {
  title: "Need more info? We're here to help.",
  cards: getQuoteSupportCards,
};
